export default __webpack_public_path__ + "static/media/info-icon-outline-white.673265c4.svg";